export default __webpack_public_path__ + "6203a59677bd20f81a79e5a1ec6a25d0.png";